//https://v5.material.angular.dev/components/autocomplete/overview

import {Component, Input, Output, OnInit, OnChanges, SimpleChanges, EventEmitter} from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { NgFor, AsyncPipe, NgIf, NgClass } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';


type Option = {
  val: string;
  desc: string;
}

@Component({
    selector: 'sms-autocomplete',
    templateUrl: 'sms-autocomplete.component.html',
    styleUrls: ['sms-autocomplete.component.scss'],
    standalone: true,
    imports: [FormsModule, MatFormFieldModule, MatInputModule, MatAutocompleteModule, ReactiveFormsModule, NgFor, AsyncPipe, MatIconModule, NgIf, NgClass, MatButtonModule]
})
export class SmsAutocomplete implements OnChanges{

  @Input() label: string = 'sms-autocomplete';
  @Input() value?: unknown;
  @Input() selectDataObjects?: unknown; // = [{val:'', desc:''}];
  @Input() selectDataList?: unknown;
  @Input() required?: boolean;
  @Input() valueField: string = 'val';
  @Input() descriptionField: string = 'desc';
  @Input() display: string = 'both';  // both means concatenate val and desc
  @Input() disabled: boolean = false;

  @Output() valueChange = new EventEmitter<unknown>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectDataObjects'] || changes['selectDataList']){
      this.processOptionsData();
    }
  }

  myControl: FormControl = new FormControl<string>(''); 
  myOptions: Option[] = [];
  filteredOptions!: Observable<Option[]>; 
  showClearButton = false;
  originalValue: any;
  previousValue: any;   // to track previous value for comparison to avoid emitting valueChange event when user reselects same value
  isDisabled: boolean;

  firstUpdate: boolean = true;

  ngOnInit() {
    this.originalValue = this.previousValue = this.value;
    this.myControl.setValue(this.value);
    this.isDisabled = this.disabled;
    this.processOptionsData();
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || ''))
    );
  }

  prevOptionsFingerprint = '';
  processOptionsData(){
    try {
      if (this.selectDataList && Array.isArray(this.selectDataList) && this.selectDataList.length > 0) {  // array of values to show in dropdown was provied as @Input
        this.myOptions = this.selectDataList.map(item => {
          return {val: item, desc: ''};
        })
      } else {   // array of objects containing values to show in dropdown was provided as @Input
          if (this.selectDataObjects && Array.isArray(this.selectDataObjects)){
            this.myOptions = this.selectDataObjects.map( item => {
              if (typeof item !== "object" || item === null || !(this.valueField in item) || (this.descriptionField && !(this.descriptionField in item)) ) {
                return {val:'', desc:''};
              }
              return {val: item[this.valueField], desc: (this.descriptionField && this.descriptionField in item) ? item[this.descriptionField] : ''}
            }).filter (item => { return item.val != ''});
          } 
      }
      const thisOptionsFingerprint = this.myOptions.length>0 ? this.myOptions.length.toString() +'-' + this.myOptions[0].val + '-' + this.myOptions[this.myOptions.length-1].val : '';

      if (!this.required) {
        this.myOptions.unshift({val:'', desc:''});
      }

      if (this.prevOptionsFingerprint == thisOptionsFingerprint){
        const nochange = true;
      }

      //this.myControl.setValue('');
      if (this.myOptions.filter( o => o.val == this.originalValue).length > 0){
        //this.myControl.setValue(this.originalValue);
        this.updateValue(this.originalValue)
      } 
      else if (this.myOptions.length>0) {
        //this.myControl.setValue(this.myOptions[0].val)
        this.updateValue(this.myOptions[0].val)
      } else {
        this.updateValue('');
      }

      this.prevOptionsFingerprint = thisOptionsFingerprint;
    }
    catch(err) {
      throw new Error('wrong data structure');
    }
  }

  updateValue(value){
    //if ( this.myControl.value !== value ) {
    if ( this.previousValue !== value ) {
      this.previousValue = value;
      this.myControl.setValue(value);
      if ( !this.firstUpdate ){
        this.valueChange.emit(value);
      }
      this.firstUpdate = false;
    }
  }

  private _filter(value: string): Option[] {
    const filterValue = value.toLowerCase();
    const result: Option[] = this.myOptions.filter(option => {
      return option.val.toLowerCase().includes(filterValue) || option.desc.toLowerCase().includes(filterValue)
    });
    if (result.length == 0){
      result.push({val: 'no items found', desc:''});
    } 
    return result;
  }
  clearInput() {
    this.myControl.setValue('');  
  }

  displayFn = (val: string): string => { // used arrow function property to bind function to this
    const display = this.myOptions
      .filter(option => option.val == val)
      .map( opt =>
        {
          if(this.display == 'both'){
            return opt.desc == '' ? opt.val : opt.val + ' - ' + opt.desc.replace(opt.val+ ' - ', ""); //.replace(opt.val,"")
          } else { 
            return this.display == 'desc' ? opt.desc : opt.val;
          }
        }
      )[0];
      return display === undefined ? val : display;
  }
  selectOption(event){
    this.valueChange.emit(event);
  }

  onAutocompleteClosed(){
    //see https://github.com/angular/components/issues/28378 for requireSelection bug and suggestion for the onAutocompleteClosed solution
    const val = this.myControl.value ?? '';
    const validValues = this.myOptions.map((o) => o.val);
    if (typeof val === 'string' && validValues.includes(val)) {
      this.updateValue(val);
    } else {
      //this.myControl.setValue(this.originalValue);
      this.updateValue(this.originalValue);
    }
  }

}
